/* LLCL C-10R — mobile/tablet navigation recovery */
(() => {
  'use strict';

  const self = document.currentScript?.src || '';
  const baseline = self.replace(/ll-localization\.js(?:\?.*)?$/, 'll-localization-c10r-baseline.js');
  const root = () => String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const english = () => String(document.documentElement.lang || 'es').toLowerCase().split('-')[0] === 'en';
  const setText = (node, value) => { if (node && node.textContent.trim() !== value) node.textContent = value; };

  const COPY = {
    es: {
      roots: {
        nuevo: ['Nuevo','Nuevas llegadas · Edición actual'],
        mujer: ['Mujer','Siluetas · Capas · Esenciales'],
        unisex: ['Unisex','Camisas · Pantalones · Capas'],
        home: ['Home Décor','Textiles · Objetos · Casa'],
        editions: ['Editions','Latidos · Huichol · Crisol · Nativo'],
        icons: ['The Icons','Selección · Más vendidos'],
        discover: ['Descubrir','Lifestyle · Aromas · Maison'],
        journal: ['Journal','Historias · Materia · Lugar']
      },
      best: 'Más vendidos',
      perfume: 'Perfumes & Aromas',
      discover: [['le-voyage','El Viaje'],['la-ville','La Ciudad'],['la-plage','La Playa']],
      ui: {
        language: 'Idioma',
        regionAria: 'Región y moneda',
        regionTitle: 'Región / moneda',
        close: 'Cerrar',
        search: 'Buscar país o moneda',
        country: 'País',
        empty: 'No se encontraron resultados.'
      }
    },
    en: {
      roots: {
        nuevo: ['New','New arrivals · Current edit'],
        mujer: ['Women','Silhouettes · Layers · Essentials'],
        unisex: ['Unisex','Shirts · Trousers · Layers'],
        home: ['Home Décor','Textiles · Objects · Home'],
        editions: ['Editions','Latidos · Huichol · Crisol · Nativo'],
        icons: ['The Icons','Selection · Best sellers'],
        discover: ['Discover','Lifestyle · Fragrance · Maison'],
        journal: ['Journal','Stories · Material · Place']
      },
      best: 'Best Sellers',
      perfume: 'Perfumes & Scents',
      discover: [['le-voyage','The Journey'],['la-ville','The City'],['la-plage','The Beach']],
      ui: {
        language: 'Language',
        regionAria: 'Region and currency',
        regionTitle: 'Region / currency',
        close: 'Close',
        search: 'Search country or currency',
        country: 'Country',
        empty: 'No results found.'
      }
    }
  };

  const loadBaseline = () => new Promise((resolve) => {
    if (window.__LLCL_LOCALIZATION_V3__ || !baseline || baseline === self) return resolve();
    const s = document.createElement('script');
    s.src = baseline;
    s.async = false;
    s.dataset.llC10rBaseline = 'true';
    s.onload = s.onerror = resolve;
    document.head.appendChild(s);
  });

  const rootKey = (item) => {
    const raw = `${item.dataset.llRootItem || ''} ${item.querySelector('.ll-mobile-drawer__root-title')?.textContent || ''}`.toLowerCase();
    if (/nuevo|\bnew\b/.test(raw)) return 'nuevo';
    if (/mujer|women/.test(raw)) return 'mujer';
    if (/unisex/.test(raw)) return 'unisex';
    if (/home/.test(raw)) return 'home';
    if (/edition|coleccion/.test(raw)) return 'editions';
    if (/the-icons|the icons|icons/.test(raw)) return 'icons';
    if (/descubrir|discover/.test(raw)) return 'discover';
    if (/journal/.test(raw)) return 'journal';
    return '';
  };

  const findDiscover = (drawer) => [...drawer.querySelectorAll('.ll-mobile-drawer__sub-panel')].find((panel) => {
    const raw = `${panel.dataset.llMobileMenu || ''} ${panel.className || ''} ${panel.querySelector('.ll-mobile-drawer__back-title')?.textContent || ''}`.toLowerCase();
    return /descubrir|discover/.test(raw);
  });

  const makeCard = (handle, label) => {
    const a = document.createElement('a');
    a.href = `${root()}collections/${handle}`;
    a.className = 'll-mobile-drawer__visual-card ll-mobile-drawer__visual-card--text ll-c10r-discover-card';
    a.dataset.llC10rDiscover = handle;
    a.innerHTML = '<div class="ll-mobile-drawer__visual-heading"><div class="ll-mobile-drawer__visual-heading-copy"><span class="ll-mobile-drawer__visual-index" aria-hidden="true"></span><span class="ll-mobile-drawer__visual-title"></span></div><span class="ll-mobile-drawer__visual-arrow" aria-hidden="true">→</span></div>';
    setText(a.querySelector('.ll-mobile-drawer__visual-title'), label);
    return a;
  };

  const patchLocalizationUI = (scope, ui) => {
    scope.querySelectorAll('.ll-localization__languages').forEach((node) => node.setAttribute('aria-label', ui.language));
    scope.querySelectorAll('.ll-localization__panel').forEach((node) => node.setAttribute('aria-label', ui.regionAria));
    scope.querySelectorAll('.ll-localization__panel-title').forEach((node) => setText(node, ui.regionTitle));
    scope.querySelectorAll('.ll-localization__close').forEach((node) => node.setAttribute('aria-label', ui.close));
    scope.querySelectorAll('.ll-localization__search').forEach((node) => {
      node.setAttribute('placeholder', ui.search);
      node.setAttribute('aria-label', ui.search);
    });
    scope.querySelectorAll('.ll-localization__country-list').forEach((node) => node.setAttribute('aria-label', ui.country));
    scope.querySelectorAll('.ll-localization__empty').forEach((node) => setText(node, ui.empty));
  };

  const renumberCards = (list) => {
    [...list.querySelectorAll(':scope > .ll-mobile-drawer__visual-card')].forEach((card, index) => {
      setText(card.querySelector('.ll-mobile-drawer__visual-index'), String(index + 1).padStart(2, '0'));
    });
  };

  const apply = () => {
    const c = english() ? COPY.en : COPY.es;
    patchLocalizationUI(document, c.ui);

    document.querySelectorAll('.ll-mobile-drawer').forEach((drawer) => {
      drawer.querySelectorAll('.ll-mobile-drawer__root-item').forEach((item) => {
        const values = c.roots[rootKey(item)];
        if (!values) return;
        setText(item.querySelector('.ll-mobile-drawer__root-title'), values[0]);
        setText(item.querySelector('.ll-mobile-drawer__root-meta'), values[1]);
      });

      drawer.querySelectorAll('a[href*="/collections/mas-vendidos"] .ll-mobile-drawer__visual-title')
        .forEach((title) => setText(title, c.best));
      drawer.querySelectorAll('a[href*="/collections/perfumes"] .ll-mobile-drawer__visual-title')
        .forEach((title) => setText(title, c.perfume));

      const panel = findDiscover(drawer);
      const list = panel?.querySelector('.ll-mobile-drawer__visual-list');
      if (list) {
        const anchor = list.firstElementChild;
        c.discover.forEach(([handle,label]) => {
          let card = list.querySelector(`a[href*="/collections/${handle}"]`);
          if (!card) card = makeCard(handle, label);
          setText(card.querySelector('.ll-mobile-drawer__visual-title'), label);
          list.insertBefore(card, anchor);
        });
        renumberCards(list);
      }
      drawer.dataset.llC10r = 'ready';
    });
  };

  const extendResponsive = async () => {
    if (document.getElementById('ll-c10r-responsive-css')) return;
    const names = ['ll-navigation.css','ll-mobile-navigation.css','ll-mobile-navigation-c06d.css'];
    const links = [...document.querySelectorAll('link[rel="stylesheet"][href]')]
      .filter((link) => names.some((name) => link.href.includes(name)));
    const chunks = [];
    for (const link of links) {
      try {
        const r = await fetch(link.href, { credentials: 'same-origin' });
        if (!r.ok) continue;
        const css = (await r.text())
          .replace(/max-width:\s*699px/g, 'max-width: 999px')
          .replace(/min-width:\s*700px/g, 'min-width: 1000px');
        chunks.push(css);
      } catch (_) {}
    }
    const style = document.createElement('style');
    style.id = 'll-c10r-responsive-css';
    style.textContent = `${chunks.join('\n')}\n@media screen and (min-width:700px) and (max-width:999px){.ll-mobile-drawer{display:block!important}.ll-header--llcl .ll-header__mega-layer,.ll-header--llcl .ll-header__language-zone,.ll-header--llcl .ll-localization-host,.ll-header--llcl .header__primary-nav>ul{display:none!important}.ll-header--llcl{grid-template-columns:minmax(0,1fr) auto minmax(0,1fr)!important;grid-template-rows:auto!important;grid-template-areas:none!important;min-height:64px!important;padding:0 16px!important}.ll-header--llcl .header__primary-nav{justify-self:start!important;display:flex!important;min-height:64px!important;padding:0!important}.ll-header--llcl .header__logo{justify-self:center!important;min-height:64px!important;padding:5px 0!important}.ll-header--llcl .header__secondary-nav{justify-self:end!important;display:flex!important;min-height:64px!important;padding:0!important}}@media screen and (min-width:1000px){.ll-mobile-drawer{display:none!important}}`;
    document.head.appendChild(style);
  };

  const boot = async () => {
    await loadBaseline();
    await extendResponsive();
    apply();
    document.addEventListener('shopify:section:load', apply);
    window.addEventListener('pageshow', apply, { once: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.__LLCL_C10R_MOBILE_NAV__ = { apply };
})();